export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-dispatch/index.js
// module id = ../../../../d3-dispatch/index.js
// module chunks = 3